import * as React from "react";
import { ObservableArray } from "azure-devops-ui/Core/Observable";
import {
    Filter,
    getKeywordFilterItem,
    getKeywordSearchResults,
    IFilterItem
} from "azure-devops-ui/Filter";
import { getListBoxItemsValue, IListBoxItem } from "azure-devops-ui/ListBox";
import { AggregateItemProvider } from "azure-devops-ui/Utilities/AggregateItemProvider";
import {
    Filter as FilterStore,
    FILTER_CHANGE_EVENT,
    IFilterState
} from "azure-devops-ui/Utilities/Filter";
import { GroupedItemProvider } from "azure-devops-ui/Utilities/GroupedItemProvider";
import { groupedItems, groups, statusItems } from "./Data";

export default class FilterCustomSearchExample extends React.Component<{}, any> {
    private provider: AggregateItemProvider<IListBoxItem>;
    private filterStore = new FilterStore();
    private groupedProvider = new GroupedItemProvider([], [], true);
    private filterItems: IFilterItem[] = [
        getKeywordFilterItem(this.filterStore),
        { name: "Status", id: "status", items: statusItems, filterItemKey: "status" },
        { name: "Second", id: "second", items: this.groupedProvider, filterItemKey: "second" }
    ];
    private activeFilter: IFilterItem | null;
    private userFilteredItems = new ObservableArray<IListBoxItem>();

    constructor(props: {}) {
        super(props);
        this.provider = new AggregateItemProvider();
        this.groupedProvider.push(...groupedItems);
        this.groupedProvider.pushGroups(...groups);
        this.provider.push(statusItems);
        this.provider.push(this.groupedProvider);

        this.filterStore.subscribe(this.onFilterChanged, FILTER_CHANGE_EVENT);
        this.state = {
            currentState: ""
        };
    }

    public render() {
        return (
            <div style={{ margin: "8px" }}>
                <Filter
                    filterByText={false}
                    filterStore={this.filterStore}
                    filterItems={this.filterItems}
                    items={this.provider}
                    onActiveFilterChanged={this.onActiveFilterChanged}
                    onFilterTextChanged={this.onFilterTextChanged}
                    userFilteredItems={this.userFilteredItems}
                />
                <div style={{ marginTop: "16px" }} className="monospaced-text">
                    <span>Current state:</span>
                    <span>{this.state.currentState}</span>
                </div>
            </div>
        );
    }

    private onActiveFilterChanged = (activeFilter: IFilterItem | null) => {
        if (activeFilter) {
            this.userFilteredItems.splice(
                0,
                this.userFilteredItems.length,
                ...getListBoxItemsValue(activeFilter.items)
            );
        } else {
            this.userFilteredItems.splice(0, this.userFilteredItems.length);
        }
        this.activeFilter = activeFilter;
    };

    private onFilterTextChanged = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue: string
    ) => {
        //Filter to only items that begin with the search term.
        const filteredItems: IListBoxItem<{}>[] = [];
        if (newValue) {
            if (!this.activeFilter || this.activeFilter.id === "status") {
                filteredItems.push(
                    ...statusItems.filter(
                        statusItem => statusItem.text && statusItem.text.indexOf(newValue) === 0
                    )
                );
            }
            if (!this.activeFilter || this.activeFilter.id === "second") {
                filteredItems.push(
                    ...this.groupedProvider.value.filter(
                        statusItem => statusItem.text && statusItem.text.indexOf(newValue) === 0
                    )
                );
            }
            if (!this.activeFilter) {
                filteredItems.push(...getKeywordSearchResults<{}>(newValue));
            }
        } else if (this.activeFilter) {
            filteredItems.push(...getListBoxItemsValue<{}>(this.activeFilter.items));
        }

        this.userFilteredItems.splice(0, this.userFilteredItems.length, ...filteredItems);
    };

    private onFilterChanged = (changedState: IFilterState) => {
        this.setState({
            currentState: JSON.stringify(this.filterStore.getState(), null, 4)
        });
    };
}
